import { format, parseISO } from 'date-fns';

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) {
    return "Invalid date";
  }
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
